const ConfigPortfolio = () => {
  return (
    <div className="config-portfolio">
      <h1>Placeholder for Portfolio Configuration</h1>
    </div>
  );
};

export default ConfigPortfolio;
